import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "60",
  viewBox: "0 0 14.788 15.824"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#7383ff",
  d: "M3.541 14.785a.691.691 0 0 0 .194.039.511.511 0 0 0 .428-.233l5.449-7.914a.5.5 0 0 0 .039-.544.516.516 0 0 0-.447-.272l-3.369-.023.972-5.211a.535.535 0 0 0-.292-.583.517.517 0 0 0-.622.156L.118 7.53a.471.471 0 0 0-.058.544.542.542 0 0 0 .467.292l3.733.019-.992 5.814a.455.455 0 0 0 .273.586zM1.577 7.338l3.811-4.822-.719 3.772a.557.557 0 0 0 .117.428.508.508 0 0 0 .389.194h3.014L4.65 12.082l.7-4.1a.557.557 0 0 0-.117-.428.49.49 0 0 0-.389-.175z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#7383ff",
  "fill-rule": "evenodd",
  d: "M11.113 8.396a3.714 3.714 0 1 0 3.675 3.714 3.681 3.681 0 0 0-3.675-3.714zm1.575 4.336h-1.575a.349.349 0 0 1-.35-.35V9.99a.35.35 0 1 1 .7 0v2.022h1.225a.349.349 0 0 1 .35.35.353.353 0 0 1-.35.37z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };